export function toRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }
  return value as Record<string, unknown>;
}

export function toPrettyText(value: unknown): string {
  if (typeof value === 'string') {
    return value;
  }
  if (value === undefined || value === null) {
    return '';
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function readStringValue(
  record: Record<string, unknown> | undefined,
  keys: string[],
): string | undefined {
  for (const key of keys) {
    const value = record?.[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }
  return undefined;
}

export const getMethodColor = (
  method?: string,
): 'red' | 'orange' | 'yellow' | 'blue' | 'green' | 'purple' | 'gray' => {
  if (!method) return 'gray';
  const m = method.toUpperCase();
  if (m === 'GET') return 'blue';
  if (m === 'POST') return 'green';
  if (m === 'PUT') return 'orange';
  if (m === 'DELETE') return 'red';
  if (m === 'PATCH') return 'purple';
  return 'gray';
};
